import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { BULK_IMPORT_CUSTOMERS } from "../customer.queries";
import {
  BulkImportCustomersMutation,
  BulkImportCustomersMutationVariables,
} from "../../../__generated__/BulkImportCustomersMutation";

export const useBulkImportCustomers = () => {
  return useMutation<BulkImportCustomersMutation, BulkImportCustomersMutationVariables>(
    BULK_IMPORT_CUSTOMERS,
    {
      refetchQueries: ["CustomersQuery"],
      update(cache) {
        evictFields(cache, ["customer", "customers"]);
      },
    }
  );
};
